import { styled } from '@mui/styles';
import Box from '@mui/material/Box';

export const StyledFooter = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.neutral.light, 
    marginTop: '45px',
    flex: '0 1 40px',

    '& .FooterContainer': {
        paddingTop: '20px', paddingBottom: '20px',

        [theme.breakpoints.down('sm')]: {
            paddingBottom: '120px'
        },

        '& .FooterMainStack, .FooterLinksStack': {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },

        '& .FooterLinksStack': {
            flexBasis: '25%',
            
            [theme.breakpoints.down('sm')]: {
                flexBasis: 'unset',
                width: '70%'
            },

            [theme.breakpoints.down(1085)]: {
                flexBasis: '40%'
            },
        },

        '& .FooterMainStack': {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column'
            },
        }
    }

}));
